import React, { useEffect, useMemo, useState } from 'react'
import Select from '../Select'
import useAllSchools from '../../hooks/useAllSchools'
import Button from '../Button'
import useLocalStorage from '../../hooks/useLocalStorage'
import Typography from '../Typography'
import classes from './SalesCallsForm.module.sass'
import useDistricts from '../../hooks/useDistricts'
import SingleSelect from '../common/Forms/SingleSelect'

const SalesCallsForm = () => {
  const [previousDistrict, setPreviousDistrict] = useLocalStorage('previousDistrict')
  const districts = useDistricts()
  const [selectedDistrict, setSelectedDistrict] = useState(parseInt(previousDistrict, 10) || '')
  const [schools, isLoaded] = useAllSchools(selectedDistrict)
  const [selectedSchool, setSelectedSchool] = useState('')

  const filteredSchools = useMemo(() => {
    if (!selectedDistrict) return schools
    if (!isLoaded) return schools

    return schools
      .filter((school) => school.districtId === selectedDistrict)
  }, [selectedDistrict, isLoaded, schools.length])

  useEffect(() => {
    if (!isLoaded) return

    setSelectedSchool((filteredSchools[0] && filteredSchools[0].id) || '')
  }, [selectedDistrict, isLoaded, schools.length])

  const changeDistrict = (option) => {
    const newDistrict = parseInt(option.value, 10)
    setSelectedDistrict(newDistrict)
    setPreviousDistrict(newDistrict)
  }

  const changeSchool = (option) => setSelectedSchool(parseInt(option.value, 10))

  if (districts.length === 0) return null

  const currentDistrict = districts.find((district) => parseInt(district.id) === selectedDistrict)

  return (
    <>
      <h3>Select District</h3>
      <SingleSelect
        selectedValue={currentDistrict ? { value: currentDistrict.id, label: currentDistrict.name } : undefined}
        handleChange={changeDistrict}
        options={districts.map((district) => ({ value: district.id, label: district.name }))}
      />
      {selectedDistrict && !isLoaded && (
        <Typography classes={classes.pTop}>Loading schools...</Typography>
      )}
      {selectedDistrict && isLoaded && (
        <>
          <h3>Select School</h3>
          <SingleSelect
            selectedValue={{ value: schools[0].id, label: `${schools[0].cityName ? `${schools[0].name} (${schools[0].cityName})` : schools[0].name} - ${schools[0].salesStat}` }}
            handleChange={changeSchool}
            options={schools.map((school) => ({ value: school.id, label: `${school.cityName ? `${school.name} (${school.cityName})` : school.name} - ${school.salesStat}` }))}
          />
        </>
      )}
      <div className={classes.pTop}>
        {selectedSchool && (
          <a href={`/sales_calls/results/${selectedSchool}`}>
            <Button fullWidth variant="primary">Continue</Button>
          </a>
        )}
      </div>
    </>
  )
}

export default SalesCallsForm
